import React from "react";
import favicon from "../../assets/images/loader.ico";
import './loader.css'

const Loader = () => {
  return (
   <div className="loader-wrapper">
      <img src={favicon} alt="loading" className="loader-image" />
    </div>
  );
};

export default Loader;